module.exports = __webpack_public_path__ + "static/banner-tablet-e80dd47b62ad25e15ccdc71f9af299be.png";